var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wa-channel-switcher" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "tippy",
              rawName: "v-tippy",
              value: { placement: "right", content: "Tüm Kanallar" },
              expression: "{ placement: 'right', content: 'Tüm Kanallar' }",
            },
          ],
          staticClass: "wa-channel-switcher__item",
          class: {
            "wa-channel-switcher__item--active": _vm.selectedChannelId === null,
          },
          on: {
            click: function ($event) {
              return _vm.$emit("change", null)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "wa-channel-switcher__avatar wa-channel-switcher__avatar--all",
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    viewBox: "0 0 24 24",
                    width: "22",
                    height: "22",
                    fill: "none",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 8L4 8l16-2-8 6zm8 6H4V9.62l8 4.97 8-4.97V18z",
                      fill: "currentColor",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _vm.totalUnread > 0
            ? _c("div", { staticClass: "wa-channel-switcher__badge" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.totalUnread > 99 ? "99+" : _vm.totalUnread) +
                    "\n        "
                ),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "wa-channel-switcher__divider" }),
      _vm._v(" "),
      _vm._l(_vm.channels, function (channel) {
        return _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  placement: "right",
                  content: _vm.getChannelTooltip(channel),
                },
                expression:
                  "{ placement: 'right', content: getChannelTooltip(channel) }",
              },
            ],
            key: channel._id,
            staticClass: "wa-channel-switcher__item",
            class: {
              "wa-channel-switcher__item--active":
                _vm.selectedChannelId === channel._id,
            },
            on: {
              click: function ($event) {
                return _vm.$emit("change", channel._id)
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "wa-channel-switcher__avatar",
                class: _vm.getChannelAvatarClass(channel),
              },
              [
                channel.name
                  ? _c("span", [
                      _vm._v(_vm._s(_vm.getChannelInitials(channel))),
                    ])
                  : _c(
                      "svg",
                      {
                        attrs: {
                          viewBox: "0 0 24 24",
                          width: "20",
                          height: "20",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z",
                            fill: "currentColor",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M12.004 2.003A9.988 9.988 0 002.017 12c0 1.762.46 3.418 1.265 4.856L2 22l5.293-1.249A9.953 9.953 0 0012.004 22c5.514 0 9.996-4.478 9.996-9.997C22 6.482 17.517 2.003 12.004 2.003z",
                            stroke: "currentColor",
                            "stroke-width": "1.5",
                            fill: "none",
                          },
                        }),
                      ]
                    ),
              ]
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "wa-channel-switcher__status-dot",
              class: _vm.getStatusDotClass(channel),
            }),
          ]
        )
      }),
      _vm._v(" "),
      _c("div", { staticClass: "wa-channel-switcher__spacer" }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "tippy",
              rawName: "v-tippy",
              value: { placement: "right", content: "Kanal Ayarları" },
              expression: "{ placement: 'right', content: 'Kanal Ayarları' }",
            },
          ],
          staticClass:
            "wa-channel-switcher__item wa-channel-switcher__item--settings",
          on: {
            click: function ($event) {
              return _vm.$emit("open-settings")
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "wa-channel-switcher__avatar wa-channel-switcher__avatar--action",
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    viewBox: "0 0 24 24",
                    width: "20",
                    height: "20",
                    fill: "none",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z",
                      fill: "currentColor",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }